export default function PaymentOptions() {
    return (
        <>
            <section id="payment-options-section">
                <div className="payment-options-container">
                    <div className="payment-note">
                        <p><strong>NOTE:</strong> You'll need to add a screenshot of the tuition fee payment in the application form in order to complete the admission process. Please contact staff or your admission counsellor for the fee clarification or to get payment details.</p>
                    </div>

                    <div className="payment-header">
                        <h2 className="section-title">UPI OPTIONS</h2>
                    </div>

                    <div className="payment-cards">
                        <div className="payment-card">
                            <h3 className="payment-title">PAY WITH PAYTM</h3>
                            <div className="payment-icon">
                                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <rect x="2" y="6" width="20" height="12" rx="2" />
                                    <circle cx="12" cy="12" r="2" />
                                    <path d="M6 12h.01M18 12h.01" />
                                </svg>
                            </div>
                            <div className="payment-details">
                                <div className="recipient-info">
                                    <span className="recipient-name">Hritisha Rewadia</span>
                                    <span className="upi-id">8769373591@ptsbi</span>
                                </div>
                                <div className="qr-code">
                                    <img src="/images/paytm-pay.png" alt="Paytm QR Code" />
                                </div>
                            </div>
                        </div>

                        <div className="payment-card">
                            <h3 className="payment-title">PAY WITH PHONEPAY</h3>
                            <div className="payment-icon">
                                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
                                    <line x1="12" y1="18" x2="12.01" y2="18" />
                                </svg>
                            </div>
                            <div className="payment-details">
                                <div className="recipient-info">
                                    <span className="recipient-name">Hritisha Rewadia</span>
                                    <span className="upi-id">8769373591@ibl</span>
                                </div>
                                <div className="qr-code">
                                    <img src="/images/phone-pay.png" alt="phonepay QR Code" />
                                </div>
                            </div>
                        </div>

                        <div className="payment-card">
                            <h3 className="payment-title">PAY WITH GOOGLEPAY</h3>
                            <div className="payment-icon">
                                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="12" r="10" />
                                    <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                                    <line x1="9" y1="9" x2="9.01" y2="9" />
                                    <line x1="15" y1="9" x2="15.01" y2="9" />
                                </svg>
                            </div>
                            <div className="payment-details">
                                <div className="recipient-info">
                                    <span className="recipient-name">Hritisha Rewadia</span>
                                    <span className="upi-id">hritisharewadia@oksbi</span>
                                </div>
                                <div className="qr-code">
                                    <img src="/images/google-pay.png" alt="Google pay QR Code" />
                                </div>
                            </div>
                        </div>
                    </div>


                    <h2 className="section-title">Bank Details</h2>
                    <div className="payment-contact">
                        <p><strong>Contact Us</strong> now for bank details for direct transfer to bank account either through Call, Email or Whatsapp.</p>
                    </div>
                </div>
            </section>
        </>
    );
} 